// starts with 0: error de servicio/cliente
// starts with 1: error de bloqueo
export enum ServiceErrorEnum {
    UPDATE_OFFICE_IN_ADD_SELLER_SERVICE_ERROR = '001',
    GET_SELLER_SERVICE_ERROR = '002',
    GET_OFFICE_BY_IP_SERVICE_ERROR = '003',
    CLIENT_ASSOCIATION_WITH_SELLER_SERVICE_ERROR = '004',
    GET_OFFICE_INFO_BY_CODE_SERVICE_ERROR = '005',
    WRONG_CHANNEL_ERROR = '006',
    SEND_OTP_SERVICE_ERROR = '007',
    GET_SELLER_NOT_FOUND_ERROR = '008',
    VALIDATE_OTP_SERVICE_ERROR = '009',
    SAVE_DATA_SELLER_ERROR = '010',
    SAVE_DATA_DISPATCHER_ERROR = '011',
    GET_DATA_DISPATCHER_ERROR = '012',
    VALIDATE_CODE_OFFICE_ERROR = '013',
    CUSTOMER_STATE_ERROR = '014',
    OLIMPIA_SELFIE_SERVICE_FAILED_ERROR = '021',
    BLOCKED_BY_SECURITY_DAYS = '100',
    BLOCKED_BY_SECURITY_MONTHS = '101',
    BLOCKED_PHONE_BY_MANY_USERS = '102',
    BLOCKED_BY_SECURITY_IP = '103',
    BLOCKED_BY_IP_INQUIRY = '104',
    BLOCKED_PHONE_BY_REEXPEDITION = '105',
    BLOCKED_INVALID_IDENTIFICATION_NUMBER = '111',
    CHECKPIN_WRONG_PASSWORD = '1-013',
    VALIDATE_TOKEN_ERROR = '1-015',
    ABSTENTION_LIST_ERROR = '0-025'
}



// WEBPACK FOOTER //
// ./src/app/enums/service-error.enum.ts